import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { postFakeLogin } from '../../Mock/fakebackend_helper';
import config from '../../config';
import Agent from '../agent';

const initialState = {
  loading: false,
  user: {},
  errors: {},
  redirectTo: null,
};

const isMockEnable = config.enableMock;

export const loginUser = createAsyncThunk('auth/login', async (data, { rejectWithValue }) => {
  try {
    let res;
    if (isMockEnable) {
      res = await postFakeLogin({ email: data.username, password: data.password });
    } else {
      res = await Agent.Auth.login(data.username, data.password);
    }
    return res;
  } catch (err) {
    let error = err;
    if (!error.response) {
      return rejectWithValue({ errors: { [err.name]: err.message } });
    }
    return rejectWithValue(error.response.body);
  }
});

export const registerUser = createAsyncThunk('auth/register', async (data, { rejectWithValue }) => {
  try {
    // let res = await agent.Auth.register(data);
    // return res;
  } catch (err) {
    let error = err;
    if (!error.response) {
      return rejectWithValue({ errors: { [err.name]: err.message } });
    }
    return rejectWithValue(error.response.body);
  }
});

export const getUser = createAsyncThunk('auth/get', async (payload, { rejectWithValue }) => {
  const { data } = await Agent.Auth.current(payload).catch((err) => {
    rejectWithValue(err);
  });
  return data;
});

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setLoading(state) {
      state.loading = true;
    },
    updateUserState(state, action) {
      if (state.errors['email or password']) {
        delete state.errors['email or password'];
      }
      if (state.errors[action.payload.key]) delete state.errors[action.payload.key];
      state.user[action.payload.key] = action.payload.value;
    },
    setUser: (state, action) => {
      state.user = action.payload;
    },
  },
  extraReducers: {
    [registerUser.pending]: (state) => {
      state.loading = true;
    },

    [registerUser.fulfilled]: (state, action) => {
      state.loading = false;
      state.user = action?.payload?.user || {};
      state.redirectTo = '/login';
    },

    [registerUser.rejected]: (state, action) => {
      state.loading = false;
      state.errors = action?.payload?.errors || {};
    },

    [loginUser.fulfilled]: (state, action) => {
      state.loading = false;
      state.user = action?.payload?.user || {};
      state.redirectTo = '/';
    },

    [loginUser.rejected]: (state, action) => {
      state.loading = false;
      state.errors = action?.payload?.errors || {};
    },

    [getUser.fulfilled]: (state, action) => {
      state.loading = false;
      state.user = action?.payload?.user || {};
      state.redirectTo = '/';
    },

    [getUser.rejected]: (state, action) => {
      state.loading = false;
      state.errors = action?.payload?.errors || {};
    },
  },
});

export const authSelector = (state) => state.auth;

export const { reducer, actions } = authSlice;

export const { setUser } = authSlice.actions;
